import { fetchApi } from '@/shared/api/fetchApi';
import { Activity, ActivitiesResponse, ActivitiesParams, CreateActivityDto } from '../types/activityTypes';

export interface UpdateActivityDto {
  type: string;
  activity_date: string;
  activity_time: string;
  address: string;
  comment: string;
  id?: string;
}

export const activitiesApi = {
  getActivities: async (params: ActivitiesParams = {}): Promise<ActivitiesResponse> => {
    const searchParams = new URLSearchParams();

    if (params.offset !== undefined) {
      searchParams.set('offset', params.offset.toString());
    }
    if (params.limit !== undefined) {
      searchParams.set('limit', params.limit.toString());
    }
    if (params.activity_type) {
      searchParams.set('activity_type', params.activity_type);
    }
    if (params.has_report !== undefined) {
      searchParams.set('has_report', params.has_report.toString());
    }
    if (params.activity_start_date) {
      searchParams.set('activity_start_date', params.activity_start_date);
    }
    if (params.activity_end_date) {
      searchParams.set('activity_end_date', params.activity_end_date);
    }

    const url = `/api/v1/activities/list?${searchParams.toString()}`;
    return fetchApi<ActivitiesResponse>(url);
  },

  createActivity: async (data: CreateActivityDto): Promise<Activity> => {
    return fetchApi<Activity>('/api/v1/activities/create', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  deleteActivity: async (id: string): Promise<Activity> => {
    return fetchApi<Activity>(`/api/v1/activities/${id}`, {
      method: 'DELETE',
    });
  },

  updateActivity: async (id: string, data: UpdateActivityDto): Promise<Activity> => {
    return fetchApi<Activity>(`/api/v1/activities/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  },
};
